export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
};

export type AdditionalBus = {
  __typename?: 'AdditionalBus';
  blockedSeats: Array<BusScheme>;
  bus?: Maybe<Bus>;
  busId?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<User>;
  carrierId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: CountryCode;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AvailableSeatsPayload = {
  __typename?: 'AvailableSeatsPayload';
  blockedSeats: Array<BusScheme>;
  bus?: Maybe<Bus>;
  route: Route;
  seats: Array<Seat>;
  seatsLeft: Scalars['Int']['output'];
};

export type AvailableSeatsWhereInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type BlogArticle = {
  __typename?: 'BlogArticle';
  category: BlogArticleCategory;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  metadataId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum BlogArticleCategory {
  Articles = 'Articles',
  News = 'News',
  Tips = 'Tips'
}

export type BlogArticleWhereInput = {
  category?: InputMaybe<BlogArticleCategory>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BlogArticleWhereUniqueInput = {
  slug: Scalars['String']['input'];
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BorderWaitingTime = {
  __typename?: 'BorderWaitingTime';
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySlug?: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['DateTime']['output'];
  minMaxTime: Array<Scalars['Int']['output']>;
  routeName: Scalars['String']['output'];
  weekday: Scalars['String']['output'];
};

export type Bus = {
  __typename?: 'Bus';
  brand: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images: Array<Image>;
  model: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
  scheme: Array<BusScheme>;
  seatsQty: Scalars['Int']['output'];
};

export type BusLocation = {
  __typename?: 'BusLocation';
  bus: Bus;
  busId: Scalars['String']['output'];
  carriage?: Maybe<Carriage>;
  carriageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  route: Route;
  routeId: Scalars['String']['output'];
};

export type BusLocationWhereInput = {
  busId: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export type BusScheme = {
  __typename?: 'BusScheme';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: BusSchemeType;
  xAxis: Scalars['Int']['output'];
  yAxis: Scalars['Int']['output'];
  zAxis: Scalars['Int']['output'];
};

export enum BusSchemeType {
  Door = 'Door',
  Other = 'Other',
  Seat = 'Seat',
  SpecialSeat = 'SpecialSeat',
  Stairs = 'Stairs',
  Table = 'Table',
  Wc = 'WC'
}

export type BusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Carriage = {
  __typename?: 'Carriage';
  carrier?: Maybe<User>;
  carrierId?: Maybe<Scalars['String']['output']>;
  customDays: Array<Scalars['String']['output']>;
  discounts: Array<Discount>;
  frequency: CarriageFrequency;
  id: Scalars['String']['output'];
  nDay?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  phones: Array<Scalars['String']['output']>;
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum CarriageFrequency {
  Custom = 'Custom',
  EveryNDay = 'EveryNDay'
}

export type CheckContrabusBookingPayload = {
  __typename?: 'CheckContrabusBookingPayload';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageHtml?: Maybe<Scalars['String']['output']>;
};

export type CheckContrabusBookingWhereInput = {
  dataBundle: Scalars['String']['input'];
  phones: Array<Scalars['String']['input']>;
};

export type City = {
  __typename?: 'City';
  country: CountryCode;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stops: Array<CityStop>;
  timeZone?: Maybe<Scalars['String']['output']>;
  translations: Array<CityTranslation>;
};

export type CityStop = {
  __typename?: 'CityStop';
  city: City;
  cityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  place: Scalars['String']['output'];
  type: CityStopType;
};

export enum CityStopType {
  Airport = 'Airport',
  BusStation = 'BusStation',
  Regular = 'Regular',
  TrainStation = 'TrainStation'
}

export type CityTranslation = {
  __typename?: 'CityTranslation';
  id: Scalars['String']['output'];
  language: Language;
  languageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CityWhereInput = {
  country?: InputMaybe<EnumCountryCodeFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};

export type CityWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ClosestAvailableOffers = {
  __typename?: 'ClosestAvailableOffers';
  dates: Array<Scalars['DateTime']['output']>;
};

export type Company = {
  __typename?: 'Company';
  addresses: Array<Address>;
  buses: Array<Bus>;
  ceo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerCompany?: Maybe<Scalars['String']['output']>;
  phones: Array<Phone>;
  plan?: Maybe<Plan>;
  refundRules?: Maybe<Array<CompanyRefundRule>>;
  review?: Maybe<CompanyReview>;
  reviews: Array<Review>;
  routes: Array<Route>;
  rules?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  socials: Array<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  websiteConfig?: Maybe<WebsiteConfig>;
  websiteConfigId?: Maybe<Scalars['String']['output']>;
};


export type CompanyBusesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyReviewsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewWhereInput>;
};


export type CompanyRoutesArgs = {
  where?: InputMaybe<RouteWhereInput>;
};

export type CompanyRefundRule = {
  __typename?: 'CompanyRefundRule';
  amount: Scalars['Decimal']['output'];
  hours: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
};

export type CompanyReview = {
  __typename?: 'CompanyReview';
  bus: Scalars['Float']['output'];
  comfort: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  drivers: Scalars['Float']['output'];
  priceQuality: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  support: Scalars['Float']['output'];
};

export enum CompanyStatus {
  Disabled = 'Disabled',
  Private = 'Private',
  Public = 'Public'
}

export type CompanyWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum CountryCode {
  At = 'AT',
  Be = 'BE',
  Bg = 'BG',
  Ch = 'CH',
  Cz = 'CZ',
  De = 'DE',
  Ee = 'EE',
  Es = 'ES',
  Fr = 'FR',
  Gr = 'GR',
  Hu = 'HU',
  It = 'IT',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Md = 'MD',
  Nl = 'NL',
  Pl = 'PL',
  Ro = 'RO',
  Sk = 'SK',
  Ua = 'UA'
}

export type CreateImageDataInput = {
  busId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type CreateMetadataDataInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrderDataInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  passengers: Array<CreateOrderPassengerDataInput>;
};

export type CreateOrderPassengerDataInput = {
  blaBlaCarRaceId?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyCode;
  departureDate: Scalars['DateTime']['input'];
  discountDesc?: InputMaybe<Scalars['String']['input']>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  octobusRaceId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  phones: Array<CreatePhoneDataInput>;
  prepaid?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  seats?: InputMaybe<Array<PassengerSeatDataInput>>;
  source: OrderRouteSource;
};

export type CreatePhoneDataInput = {
  messengers?: InputMaybe<Array<Messenger>>;
  phone: Scalars['String']['input'];
};

export enum CurrencyCode {
  Czk = 'CZK',
  Eur = 'EUR',
  Pln = 'PLN',
  Uah = 'UAH',
  Usd = 'USD'
}

export type DateTimeFilter = {
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rule?: Maybe<DiscountRule>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum DiscountRule {
  Amount = 'Amount',
  Overwrite = 'Overwrite',
  Percent = 'Percent'
}

export type DuplicatedOrderWhereInput = {
  offerId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DynamicPrice = {
  __typename?: 'DynamicPrice';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  rule: DynamicPriceRule;
  startDate: Scalars['DateTime']['output'];
};

export enum DynamicPriceRule {
  Amount = 'Amount',
  Overwrite = 'Overwrite',
  Percent = 'Percent'
}

export type EnumCountryCodeFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<EnumCountryCodeFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumLanguageCodeFilter = {
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<EnumLanguageCodeFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumOrderChannelFilter = {
  equals?: InputMaybe<OrderChannel>;
  in?: InputMaybe<Array<OrderChannel>>;
  not?: InputMaybe<EnumOrderChannelFilter>;
  notIn?: InputMaybe<Array<OrderChannel>>;
};

export type EnumOrderPaymentProviderFilter = {
  equals?: InputMaybe<OrderPaymentProvider>;
  in?: InputMaybe<Array<OrderPaymentProvider>>;
  not?: InputMaybe<EnumOrderPaymentProviderFilter>;
  notIn?: InputMaybe<Array<OrderPaymentProvider>>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<EnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<EnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumRouteStatusFilter = {
  equals?: InputMaybe<RouteStatus>;
  in?: InputMaybe<Array<RouteStatus>>;
  not?: InputMaybe<EnumRouteStatusFilter>;
  notIn?: InputMaybe<Array<RouteStatus>>;
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  createdAt: Scalars['DateTime']['output'];
  currency: CurrencyCode;
  id: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type ExternalOfferData = {
  __typename?: 'ExternalOfferData';
  blaBlaCarRaceId?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  octobusRaceId?: Maybe<Scalars['String']['output']>;
};

export type ExternalOfferDataWhereInput = {
  externalOfferId: Scalars['String']['input'];
  routeSource: OrderRouteSource;
};

export enum FilterOrdersBy {
  CreatedAt = 'CreatedAt',
  DepartureDate = 'DepartureDate'
}

export type Image = {
  __typename?: 'Image';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type ImageWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Language = {
  __typename?: 'Language';
  code: LanguageCode;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguageCode {
  Cs = 'CS',
  En = 'EN',
  Pl = 'PL',
  Ru = 'RU',
  Uk = 'UK'
}

export type LanguageConnectDisconnectInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LanguageWhereInput = {
  code?: InputMaybe<EnumLanguageCodeFilter>;
};

export type LanguageWhereUniqueInput = {
  code: LanguageCode;
};

export enum Messenger {
  FacebookMessenger = 'FacebookMessenger',
  InstagramMessenger = 'InstagramMessenger',
  Signal = 'Signal',
  Telegram = 'Telegram',
  Viber = 'Viber',
  WeChat = 'WeChat',
  WhatsApp = 'WhatsApp'
}

export type Metadata = {
  __typename?: 'Metadata';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MetadataDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bookTickets: Array<Ticket>;
  checkContrabusBooking: CheckContrabusBookingPayload;
  createOrder: Array<Ticket>;
  refreshOffers: Array<Offer>;
  updateTickets: Array<Ticket>;
};


export type MutationBookTicketsArgs = {
  data: TicketsWhereInput;
};


export type MutationCheckContrabusBookingArgs = {
  where: CheckContrabusBookingWhereInput;
};


export type MutationCreateOrderArgs = {
  data: CreateOrderDataInput;
};


export type MutationRefreshOffersArgs = {
  data: RefreshOfferDataInput;
};


export type MutationUpdateTicketsArgs = {
  data: Array<UpdateTicketDataInput>;
};

export type Offer = {
  __typename?: 'Offer';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  borderWaitingMinMaxTime?: Maybe<Array<Scalars['Int']['output']>>;
  discounts: Array<Discount>;
  id: Scalars['String']['output'];
  prices: Array<Price>;
  seatsLeft: Scalars['Int']['output'];
  slices: Array<Slice>;
  source: OrderRouteSource;
};

export type OfferWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type OffersPayload = {
  __typename?: 'OffersPayload';
  results: Array<Offer>;
  source: OrderRouteSource;
};

export type OffersWhereInput = {
  arrivalCitySlug: Scalars['String']['input'];
  departureCitySlug: Scalars['String']['input'];
  departureDate: Scalars['DateTime']['input'];
  passengersQty: Scalars['Int']['input'];
};

export enum OrderChannel {
  Api = 'Api',
  Application = 'Application',
  Backoffice = 'Backoffice',
  CarrierWebsite = 'CarrierWebsite',
  Website = 'Website'
}

export enum OrderPaymentProvider {
  LiqPay = 'LiqPay',
  Stripe = 'Stripe'
}

export enum OrderRouteSource {
  BlaBlaCar = 'BlaBlaCar',
  ContraBus = 'ContraBus',
  Klr = 'Klr',
  OctoBus = 'OctoBus',
  PrexSell = 'PrexSell',
  Toco = 'Toco'
}

export enum OrderStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  ConfirmedAutomatically = 'ConfirmedAutomatically',
  NotConfirmed = 'NotConfirmed',
  Processing = 'Processing',
  Refund = 'Refund',
  Uncompleted = 'Uncompleted',
  Waiting = 'Waiting'
}

export type Passenger = {
  __typename?: 'Passenger';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAppOrder: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isRegular: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phones: Array<Phone>;
};

export type PassengerSeatDataInput = {
  busSeatId?: InputMaybe<Scalars['String']['input']>;
  busSeatLabel?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export type PassengerWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentStatus {
  Booked = 'Booked',
  Paid = 'Paid',
  Prepaid = 'Prepaid',
  Unpaid = 'Unpaid'
}

export enum PermissionType {
  Partner = 'Partner',
  Website = 'Website'
}

export type Phone = {
  __typename?: 'Phone';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  messengers: Array<Messenger>;
  passenger?: Maybe<Passenger>;
  passengerId?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type PhoneCodeDataInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
};

export type PhoneConnectOrCreateInput = {
  create: CreatePhoneDataInput;
  where: PhoneWhereUniqueInput;
};

export type PhoneListRelationFilter = {
  every?: InputMaybe<PhoneWhereInput>;
  none?: InputMaybe<PhoneWhereInput>;
  some?: InputMaybe<PhoneWhereInput>;
};

export type PhoneNestedObjectInputType = {
  connectOrCreate?: InputMaybe<Array<PhoneConnectOrCreateInput>>;
  disconnect?: InputMaybe<Array<PhoneWhereUniqueInput>>;
};

export type PhoneUpsertInput = {
  create: CreatePhoneDataInput;
  update: UpdatePhoneDataInput;
  where: PhoneWhereUniqueInput;
};

export type PhoneWhereInput = {
  id?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type PhoneWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  tier: PlanTier;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlanTier {
  Basic = 'Basic',
  Free = 'Free',
  Pro = 'Pro'
}

export type PopularDestinationWhereInput = {
  citySlug: Scalars['String']['input'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Decimal']['output'];
  currency: CurrencyCode;
  id: Scalars['String']['output'];
};


export type PriceAmountArgs = {
  where?: InputMaybe<PriceAmountWhereInput>;
};

export type PriceAmountWhereInput = {
  departureDate: DateTimeFilter;
};

export type Promocode = {
  __typename?: 'Promocode';
  amount: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rule: PromocodeRule;
  used: Scalars['Int']['output'];
};

export enum PromocodeRule {
  Percent = 'Percent'
}

export type PromocodeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  availableSeats: Array<AvailableSeatsPayload>;
  blaBlaCarOffers: OffersPayload;
  blogArticle: BlogArticle;
  blogArticles: Array<BlogArticle>;
  borderWaitingTimes: Array<BorderWaitingTime>;
  bus?: Maybe<Bus>;
  busesLocations: Array<BusLocation>;
  cities: Array<City>;
  company?: Maybe<Company>;
  contrabusOffers: OffersPayload;
  duplicatedTickets: Array<Ticket>;
  externalOfferData: ExternalOfferData;
  klrOffers: OffersPayload;
  latestExchangeRates: Array<ExchangeRate>;
  octobusOffers: OffersPayload;
  offers: OffersPayload;
  phone?: Maybe<Phone>;
  signature?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Stats>;
  tickets: Array<Ticket>;
  tocobusOffers: OffersPayload;
};


export type QueryAvailableSeatsArgs = {
  where: AvailableSeatsWhereInput;
};


export type QueryBlaBlaCarOffersArgs = {
  where: OffersWhereInput;
};


export type QueryBlogArticleArgs = {
  where: BlogArticleWhereUniqueInput;
};


export type QueryBlogArticlesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogArticleWhereInput>;
};


export type QueryBusArgs = {
  where: BusWhereUniqueInput;
};


export type QueryCitiesArgs = {
  where?: InputMaybe<CityWhereInput>;
};


export type QueryCompanyArgs = {
  where?: InputMaybe<CompanyWhereUniqueInput>;
};


export type QueryContrabusOffersArgs = {
  where: OffersWhereInput;
};


export type QueryDuplicatedTicketsArgs = {
  where: DuplicatedOrderWhereInput;
};


export type QueryExternalOfferDataArgs = {
  where: ExternalOfferDataWhereInput;
};


export type QueryKlrOffersArgs = {
  where: OffersWhereInput;
};


export type QueryOctobusOffersArgs = {
  where: OffersWhereInput;
};


export type QueryOffersArgs = {
  where: OffersWhereInput;
};


export type QueryPhoneArgs = {
  where: PhoneWhereInput;
};


export type QuerySignatureArgs = {
  data: Scalars['String']['input'];
};


export type QueryTicketsArgs = {
  where: TicketsWhereInput;
};


export type QueryTocobusOffersArgs = {
  where: OffersWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Intensitive = 'intensitive'
}

export type RefreshOfferDataInput = {
  offersIds: Array<Scalars['String']['input']>;
};

export type Review = {
  __typename?: 'Review';
  answerText?: Maybe<Scalars['String']['output']>;
  bus: Scalars['Int']['output'];
  comfort: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  drivers: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  orderInfo?: Maybe<ReviewOrderInfo>;
  passenger: Passenger;
  passengerId: Scalars['String']['output'];
  priceQuality: Scalars['Int']['output'];
  rating: Scalars['Float']['output'];
  support: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ReviewOrderInfo = {
  __typename?: 'ReviewOrderInfo';
  carriageName?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySlug?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  firstDriver?: Maybe<User>;
  routeName?: Maybe<Scalars['String']['output']>;
  secondDriver?: Maybe<User>;
  thirdDriver?: Maybe<User>;
};

export type ReviewWhereInput = {
  AND?: InputMaybe<Array<ReviewWhereInput>>;
  OR?: InputMaybe<Array<ReviewWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
};

export type ReviewWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Route = {
  __typename?: 'Route';
  carriages: Array<Carriage>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  services?: Maybe<Array<RouteService>>;
  slug: Scalars['String']['output'];
  stops: Array<Stop>;
};

export enum RouteAccess {
  Booking = 'Booking',
  Management = 'Management',
  Order = 'Order'
}

export type RouteOrderByInput = {
  companyId?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type RoutePermission = {
  __typename?: 'RoutePermission';
  accesses: Array<RouteAccess>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  type: PermissionType;
};

export type RouteService = {
  __typename?: 'RouteService';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  translations: Array<RouteServiceTranslation>;
};

export type RouteServiceTranslation = {
  __typename?: 'RouteServiceTranslation';
  id: Scalars['String']['output'];
  language: Language;
  name: Scalars['String']['output'];
};

export enum RouteStatus {
  Archived = 'Archived',
  Disabled = 'Disabled',
  Draft = 'Draft',
  Private = 'Private',
  Public = 'Public'
}

export type RouteTranslation = {
  __typename?: 'RouteTranslation';
  id: Scalars['String']['output'];
  language: Language;
  name: Scalars['String']['output'];
};

export type RouteWhereInput = {
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRouteStatusFilter>;
  stops?: InputMaybe<StopListRelationFilter>;
};

export type RouteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Seat = {
  __typename?: 'Seat';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type SeatsWhereInput = {
  routeId: Scalars['String']['input'];
};

export type Segment = {
  __typename?: 'Segment';
  arrivalStop: Stop;
  arrivalStopId: Scalars['String']['output'];
  departureStop: Stop;
  departureStopId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['String']['output']>;
};

export type SegmentWhereInput = {
  AND?: InputMaybe<Array<SegmentWhereInput>>;
  OR?: InputMaybe<Array<SegmentWhereInput>>;
  arrivalStop?: InputMaybe<StopWhereInput>;
  departureStop?: InputMaybe<StopWhereInput>;
  route?: InputMaybe<RouteWhereInput>;
};

export type Slice = {
  __typename?: 'Slice';
  additionalBuses: Array<AdditionalBus>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  blockedSeats?: Maybe<Array<BusScheme>>;
  bus?: Maybe<Bus>;
  carriage?: Maybe<Carriage>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** The first one, in the array - is a segment id, others - are the transfers ids */
  id: Scalars['String']['output'];
  route?: Maybe<SliceRoute>;
  seat?: Maybe<Seat>;
  stops: Array<Stop>;
};

export type SliceRoute = {
  __typename?: 'SliceRoute';
  company?: Maybe<Company>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<RoutePermission>;
  services: Array<RouteService>;
  slug?: Maybe<Scalars['String']['output']>;
  translations: Array<RouteTranslation>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Stats = {
  __typename?: 'Stats';
  passengers?: Maybe<Scalars['Int']['output']>;
  routesMade?: Maybe<Scalars['Int']['output']>;
};

export type Stop = {
  __typename?: 'Stop';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  arrivalDay?: Maybe<Scalars['Int']['output']>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  city: City;
  cityStopId?: Maybe<Scalars['String']['output']>;
  departureDay?: Maybe<Scalars['Int']['output']>;
  departureTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

export type StopListRelationFilter = {
  every?: InputMaybe<StopWhereInput>;
  none?: InputMaybe<StopWhereInput>;
  some?: InputMaybe<StopWhereInput>;
};

export type StopOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type StopWhereInput = {
  city?: InputMaybe<CityWhereInput>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  busLocation: BusLocation;
};


export type SubscriptionBusLocationArgs = {
  where?: InputMaybe<BusLocationWhereInput>;
};

export type Ticket = {
  __typename?: 'Ticket';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  carriageDiscount?: Maybe<Discount>;
  createdAt: Scalars['DateTime']['output'];
  departureDate: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  id: Scalars['String']['output'];
  initialPrice?: Maybe<Price>;
  isArchived: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  passenger: Passenger;
  paymentStatus: PaymentStatus;
  prepaid?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Price>;
  promocode?: Maybe<Promocode>;
  reviewId?: Maybe<Scalars['String']['output']>;
  slices: Array<Slice>;
  source: OrderRouteSource;
  status?: Maybe<OrderStatus>;
};

export type TicketWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type TicketsWhereInput = {
  ids: Array<Scalars['String']['input']>;
};

export type UpdateImageDataInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMetadataDataInput = {
  data: MetadataDataInput;
};

export type UpdatePassengerDataInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneCodeDataInput>>;
};

export type UpdatePhoneDataInput = {
  messengers?: InputMaybe<Array<Messenger>>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTicketDataInput = {
  update: UpdateTicketUpdateDataInput;
  where: TicketWhereUniqueInput;
};

export type UpdateTicketUpdateDataInput = {
  discountId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phones: Array<CreatePhoneDataInput>;
  seats?: InputMaybe<Array<PassengerSeatDataInput>>;
};

export type User = {
  __typename?: 'User';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum UserRole {
  Admin = 'Admin',
  Agent = 'Agent',
  Carrier = 'Carrier',
  Dispatcher = 'Dispatcher',
  Driver = 'Driver'
}

export type WebsiteConfig = {
  __typename?: 'WebsiteConfig';
  additionalRoutesCompanies: Array<Company>;
  additionalRoutesSources: Array<OrderRouteSource>;
  applePayDomainFileUrl?: Maybe<Scalars['String']['output']>;
  defaultMetadata?: Maybe<Metadata>;
  defaultMetadataId?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  liqpayPrivateKey?: Maybe<Scalars['String']['output']>;
  liqpayPublicKey?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export enum Weekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}
